import { render, staticRenderFns } from "./queue-trend-plot.vue?vue&type=template&id=3200fade&scoped=true&"
import script from "./queue-trend-plot.vue?vue&type=script&lang=js&"
export * from "./queue-trend-plot.vue?vue&type=script&lang=js&"
import style0 from "./queue-trend-plot.vue?vue&type=style&index=0&id=3200fade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200fade",
  null
  
)

export default component.exports